<template>
    <section :style="fullWidth ? 'width: 100%;' : '' ">
        <div class="field">
            <label class="label">{{ label }}</label>
            <div class="control is-flex" :class="{ 'searchIdName-desativado': selecionadoDesativado }">
                <input type="number"
                       class="input"
                       v-model="inputid"
                       @change="getId"
                       :readonly="leitura"
                       :disabled="leitura"
                       style="width: 24%;" />
                <b-autocomplete :data="data"
                                :class="{ 'searchIdName-autocomplete-desativado': selecionadoDesativado }"
                                icon="magnify"
                                ref="autocomplete"
                                :field="nomeCampo"
                                :loading="isFetching"
                                @typing="getAsyncData"
                                :readonly="leitura"
                                :disabled="leitura"
                                @select="selectItem"                                
                                :style="autocompleteStyle">
                    <template #empty>
                        Nenhum {{ label }} encontrado
                    </template>
                    <template #default="props">
                        <div class="is-flex is-justified-between">
                            <span :class="{ 'has-text-danger': props.option.desativado }">{{ props.option[nomeCampo] }}</span>
                            <span class="tag">{{ props.option.id }}</span>
                        </div>
                        <div v-if="infoConvenio">
                            <div class="is-flex is-flex-direction-column is-size-7" v-if="campos && campos.length">
                                <span v-for="item in campos" :key="item.campo">
                                    <template v-if="item.nome && item.campo && props.option[item.campo]">
                                        {{ item.nome }}: <b>{{ props.option[item.campo] }}</b>
                                    </template>
                                </span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="is-flex is-justified-between" v-if="campos && campos.length">
                                <span v-for="item in campos" :key="item.campo">{{item.nome}}: <b>{{ props.option[item.campo] }}</b></span>
                            </div>
                        </div>
                        <div v-for="item in campos" :key="item.campo">
                            <span v-if="props.option[item.observacao] != null && config.exibirObservacaoMedicoNaBusca">{{ $t('GUIAATENDIMENTO.OBSERVACOES') }}: {{ props.option[item.observacao] }}</span>
                        </div>
                    </template>
                </b-autocomplete>
                <slot></slot>
            </div>
        </div>
    </section>
</template>

<script>
    import http from '@/http'
    import debounce from 'lodash/debounce'
    import { mapState } from 'vuex'
    import { hasSlot } from '@/utils/vueCompat'

    export default {
        props: {
            id: Number,
            nome: String,
            label: String,
            table: String,
            trazDesativado: Boolean,  
            trazCarteira: Boolean,    
            infoConvenio: Boolean,
            fullWidth:{
                type: Boolean,
                defaut: false
            },      
            field: null,
            searchField: null,
            leitura: null,
            campos: null,            
            camposAdicionais: {
                type: String,
                default: ''
            },
            codigoExterno: {
                type: Boolean,
                default: false
            }                
                        
        },
        data() {
            return {
                data: [],
                inputid: this.id,
                isFetching: false,
                nomeCampo: 'nome',
                campoBusca: 'nome',
                selecionadoDesativado: false
            }
        },
        mounted() {
            
            this.nomeCampo = this.field ? this.field : this.nomeCampo;
            this.campoBusca = this.searchField ? this.searchField : this.campoBusca;
            if (this.id){
                this.inputid = this.id
                this.getId()
            }
        },
        watch: {
            id() {
                this.inputid = this.id
                this.getId()
            },
            field(){
                this.nomeCampo = this.field ? this.field : this.nomeCampo;
            },
            searchField(){
                this.campoBusca = this.searchField ? this.searchField : this.campoBusca;
            }
        },
        computed: {
            hasDefaultSlot() {
                return hasSlot(this)
            },
            autocompleteStyle() {
                return "width: " +
                        (this.hasDefaultSlot
                            ? "69"
                            : "75") + "%"
            },
            ...mapState([
                'config',
            ])
        },
        
        methods: {
            getAsyncData: debounce(function (name) {
                if (!name.length) {
                    this.data = []
                    return
                }                
                this.isFetching = true;

                    let url =`/api/Search/${this.table}?${this.campoBusca}=${name}&trazDesativado=${this.trazDesativado}${this.camposAdicionais}`;

                    if(this.codigoExterno){
                        url =`/api/Search/${this.table}?${this.campoBusca}=${name}&codigoExterno=${this.codigoExterno}&trazDesativado=${this.trazDesativado}${this.camposAdicionais}`;
                    }       

                http.get(url)
                    .then(({ data }) => {
                        this.data = []
                        data.forEach((item) => this.data.push(item))
                    })
                    .catch((error) => {
                        this.data = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })
            }, 500),
            getId() {
                if(!this.inputid){
                    this.selecionadoDesativado = false;
                }

                if(this.inputid == ""){                    
                    this.inputid = null;                    
                    this.selecionadoDesativado = false;
                    this.$refs.autocomplete.setSelected({
                        [this.nomeCampo]: null,
                        data: null
                    });
                    this.$emit('update:id', this.inputid);      
                    this.$emit('update:nome', null);         
                }
                if(this.inputid && !this.isFetching){
                    let url =`/api/Search/${this.table}Id?id=${this.inputid}&trazDesativado=${this.trazDesativado}${this.camposAdicionais}`;
                    
                    if(this.codigoExterno){
                        url =`/api/Search/${this.table}Id?codigoExterno=${this.inputid}&trazDesativado=${this.trazDesativado}${this.camposAdicionais}`;
                    }       
                                                    
                    this.isFetching = true
                    const idInputAjax = this.inputid;
                    http.get(url)
                        .then(({ data }) => {
                            if(data.fail){
                                this.$buefy.toast.open({
                                    duration: 3000,
                                    message: this.table + " " + idInputAjax + ' não encontrado.',
                                    type: 'is-danger',
                                    queue: false
                                })
                                this.inputid = null
                                this.selecionadoDesativado = false;
                                this.$refs.autocomplete.setSelected({
                                    [this.nomeCampo]: null,
                                    data: null
                                })   
                                this.$emit('update:id', this.inputid)  
                                this.$emit('update:nome', null);         
                            }
                            else {
                                this.selecionadoDesativado = data.desativado === true;
                                this.$emit('update:id', parseInt(this.inputid))  
                                this.$emit('update:nome', data[this.nomeCampo]);
                                
                                if(this.trazCarteira){
                                    this.$emit('update:carteiraPadrao', data.carteiraPadrao);
                                }
                                
                                this.$refs.autocomplete.setSelected({
                                    [this.nomeCampo]: data[this.nomeCampo],
                                    data: data
                                })
                            }
                            
                        })
                        .catch((error) => {
                            this.data = []
                            throw error
                        })
                        .finally(() => {
                            this.isFetching = false
                        })
                }
            },            
            selectItem(option) {                
                if (option.id){
                    this.inputid = option.id
                    this.selecionadoDesativado = option.desativado === true;
                    this.$emit('update:id', option.id)
                    this.$emit('update:nome', option.nome);
                }
                this.$emit('item', option);
            }
        }
    }
</script>

<style>
    .searchIdName-desativado input.input
    {
        border-color: #f14668 ;
        box-shadow: 0 0 0 0.125em rgba(241, 70, 104, 0.25) ;
    }

    .searchIdName-autocomplete-desativado input.input
    {
        color: #f14668;
    }
</style>
